import { render, staticRenderFns } from "./error.vue?vue&type=template&id=5c369e87&scoped=true&lang=pug&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"
import style0 from "./error.vue?vue&type=style&index=0&id=5c369e87&prod&lang=scss&"
import style1 from "./error.vue?vue&type=style&index=1&id=5c369e87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c369e87",
  null
  
)

export default component.exports